import { CLIENT_TYPE } from '@/config';

export type AuthorizationInfoEntity = {
  tenantAlias?: string;
  userPoolId?: string;
  clientId?: string;
  apiKey?: string;
};

export type AuthorizationTenantServiceInfoResponse = {
  data?: {
    authorizationTenantServiceInfo: Array<AuthorizationInfoEntity>;
  };
  errors?: Array<unknown>;
};

export type AuthorizationInfoResponse = {
  data?: {
    authorizationInfo: Array<AuthorizationInfoEntity>;
  };
  errors?: Array<unknown>;
};

export const fetchAuthorizationInfo = async (
  tenantAlias: string,
  authorizationInfoApiUrl: string,
  authInfo: string
): Promise<AuthorizationInfoResponse> => {
  const url = new URL(authorizationInfoApiUrl);

  url.searchParams.append('tenantAlias', tenantAlias);
  url.searchParams.append('path', CLIENT_TYPE);

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Api-Key': authInfo,
    },
  })
    .then(async (res: Response) => {
      return (await res.json()) as AuthorizationInfoResponse;
    })
    .catch((reason) => {
      console.log(reason);

      return { errors: [reason] } as AuthorizationInfoResponse;
    });
};

export const fetchAuthorizationTenantServiceInfo = async (
  variables: {
    tenantAlias: string;
    serviceId: string;
  },
  authorizationTenantServiceInfoApiUrl: string,
  authInfo: string
): Promise<AuthorizationTenantServiceInfoResponse> => {
  const url = new URL(authorizationTenantServiceInfoApiUrl);

  url.searchParams.append('tenantAlias', variables.tenantAlias);
  url.searchParams.append('serviceId', variables.serviceId);

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Api-Key': authInfo,
    },
  })
    .then(async (res: Response) => {
      return (await res.json()) as AuthorizationTenantServiceInfoResponse;
    })
    .catch((reason) => {
      console.log(reason);

      return { errors: [reason] } as AuthorizationTenantServiceInfoResponse;
    });
};
